import React from 'react'
import {
  View,
  StyleSheet,
  Text,
  TextStyle,
  StyleProp,
  ViewStyle,
} from 'react-native'
import { IconProcessed, IconProcessedWhite } from '../../../../assets/icons'
import { useTranslation } from 'react-i18next'
import useIsMobile from '../../../Contractor/PayablesTab/hooks/useIsMobile'

type Props = {
  containerStyle?: StyleProp<ViewStyle>
  titleStyle?: StyleProp<TextStyle>
  infoStyle?: StyleProp<TextStyle>
}

export const InvoiceProcessed: React.FC<Props> = ({
  containerStyle,
  titleStyle,
  infoStyle,
}) => {
  const { t } = useTranslation('global')
  const isMobile = useIsMobile()

  return (
    <View
      style={[styles.container, containerStyle]}
      testID={'invoice-payment-processing-container'}
    >
      {isMobile ? <IconProcessed /> : <IconProcessedWhite />}
      <View style={styles.textsContainer} testID={'invoice-processed-message'}>
        <Text
          style={[styles.mainText, titleStyle]}
          testID={'invoice-processed-main-text'}
        >
          {isMobile
            ? t('integrations.pay-as-guest.invoice-processed.mobile-title')
            : t('integrations.pay-as-guest.invoice-processed.title')}
        </Text>
        <Text
          style={[styles.infoText, infoStyle]}
          testID={'invoice-processed-info-text'}
        >
          {isMobile
            ? t('integrations.pay-as-guest.invoice-processed.mobile-info')
            : t('integrations.pay-as-guest.invoice-processed.info')}
        </Text>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 30,
    maxWidth: '94%',
  },
  textsContainer: {
    marginTop: 30,
    justifyContent: 'center',
    alignItems: 'center',
  },
  mainText: {
    fontFamily: 'Inter',
    fontSize: 24,
    fontWeight: '700',
    lineHeight: 32,
    textAlign: 'center',
    color: '#19262F',
    //width: 340,
    maxWidth: '100%',
  },
  infoText: {
    marginTop: 8,
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 32,
    textAlign: 'center',
    color: '#19262F',
    //width: 445,
    maxWidth: '100%',
  },
})
